import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const exactOnline = defineConnector({
  identifier: "exactOnline",
  name: "Exact Online",
  tagLine: "Accounting and business software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ extension }) =>
    extension
      ? `https://start\\.exactonline\\.${extension.replace(/\./g, "\\.")}/.*`
      : ".*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Exact Online instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Exact Online instance.",
        },
        {
          kind: "input",
          label: "Domain Extension",
          placeholder: "nl",
          required: true,
          target: { kind: "configuration", field: "extension" },
          helperText: "The domain extension of your Exact Online account",
        },
      ],
    },
    {
      title: "Create an Exact Online app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Exact Online developer portal](https://developer.exactonline.com/) and register an app for the APIs you want to use. Copy the client ID and client secret, and choose the correct country extension for your Exact Online account.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/exactOnline/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Exact Online account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Exact Online account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://start.exactonline.${configuration.extension}/api/oauth2/auth`,
    tokenEndpoint: (configuration) =>
      `https://start.exactonline.${configuration.extension}/api/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://start.exactonline.${configuration.extension}/`,
  },
  publicEnvVars: ({ extension }) => ({
    EXACT_ONLINE_EXTENSION: extension || "",
  }),
});
